import React from 'react';
import { Button } from 'react-bootstrap';
import { Field } from 'react-final-form';
import DatePickerAdapter from '../../DatePickerAdapter.jsx';
import { FormError } from '../../FormError.jsx';

const SelectDateForm = ({
  onCancel,
  submitting,
  handleSubmit,
  formRef,
  submitFailed,
  submitError,
  values,
}) => {
  return (
    <form
      onSubmit={handleSubmit}
      ref={formRef}
      className="select-survey-date-form"
    >
      <Field
        id="surveyFormStartDate"
        name="startDate"
        label="Start Date"
        placeholderText="Start Date"
        dateFormat="MM/DD/YYYY"
        isClearable={values.startDate}
        component={DatePickerAdapter}
      />

      <Field
        id="surveyFormEndDate"
        name="endDate"
        label="End Date"
        placeholderText="End Date"
        dateFormat="MM/DD/YYYY"
        isClearable={values.endDate}
        component={DatePickerAdapter}
      />
      {submitFailed && submitError ? (
        <FormError submitError={submitError} />
      ) : null}
      <div className="flex flex-justify">
        <Button bsStyle="default" style={{ flex: 1 }} onClick={onCancel}>
          Cancel
        </Button>

        <Button
          className="m-l-12"
          bsStyle="primary"
          style={{ flex: 1 }}
          type="submit"
          disabled={submitting}
        >
          {submitting ? 'Saving...' : 'Save'}
        </Button>
      </div>
    </form>
  );
};
export default SelectDateForm;
